module.exports = __webpack_public_path__ + "img/img_banner_cdn.26fc0094.png";